<template>
    <!-- Modal -->
    <div id="bonus-modal">
        <div id="listing-modal-wrapper">
            <div id="logout-modal-wrapper">
                <div class="modal fade show"
                     tabindex="-1" role="dialog"
                     aria-labelledby="exampleModalCenterTitle"
                     aria-hidden="true"
                     style="display: block"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span class="close-span" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="confirmation-modal-body modal-body">
                                <ul class="reset-list">
                                    <li v-for="(loyalty, index) in user.user.loyalties" :key="index">
                                        <div>
                                            <h5>{{ loyalty.name }}</h5>
                                            <small>{{ loyalty.activeFrom | date }}</small>
                                        </div>
                                        <div>
                                            <p>{{ (loyalty.balance / loyalty.balanceUnitDivision).toFixed(2) }} CHF</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BonusModal from './BonusModal';
export default BonusModal;
</script>
